module.exports = __webpack_public_path__ + "img/Seriea.c616e9f0.png";